import { render, staticRenderFns } from "./DoctorApp.vue?vue&type=template&id=16f61752&"
import script from "./DoctorApp.vue?vue&type=script&lang=js&"
export * from "./DoctorApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports